import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../styles/reviewrequest.css";
import { useAppDispatch, useAppSelector } from "../hooks/useSelector";
import RejectModal from "../components/reejectmodal";

import DeliveryCodeModal from "../components/delivercode";
import { get, post, put } from "../config/api";
import { RequestState, ROLES, VIEWER_ROLES } from "../constants/textconstants";
import {
  updateCurrentRequest,
  updateCurrentRequestActive,
} from "../store/slices/pendingRequests";
import { BackArrow, Download, Info } from "../constants";
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import { showError, showToast } from "../store/slices/formconfig";
import CancelModal from "../components/cancelmodal";
import DistributorMappingModal from "../components/distributorMappingModal";
import { formatDateToDDMMYYYY } from "../utils/dateUtils";
import { downloadFile, getFileNameFromUrl } from "../helper-functions";
import { TESTING_DATA } from "../constants/isTesting";
import ApproveModal from "../components/approvemodal";
import { Loader } from "../components/loader";

const ReviewRequestPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isReadOnly = location.state?.readOnly === true;
  const dispatch = useAppDispatch();

  const requests = useAppSelector((state: any) => state.requests.data);
  const issuedRequests = useAppSelector(
    (state: any) => state.requests.issuedCertificates
  );
  const userData = useAppSelector((state: any) => state.formConfig.user);

  const [requestData, setRequestData] = useState<any>({});
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);

  const [certificateData, setCertificateData] = useState<any | null>(null);
  const [bookletData, setBookletData] = useState<any>({});

  const [showDeliveryCodeModal, setShowDeliveryCodeModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showDistributorMappingModal, setShowDistributorMappingModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);

  // const fetchCertificateData = async (id: any) => {
  //   try {
  //     const response = await get(API_ENDPOINTS.CERTIFICATE_BY_ID(id!));
  //     if (response) {
  //       console.log(response, "----000--00");
  //       setCertificateData(response.certificate);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch certificate details:", error);
  //     setCertificateData(null);
  //   }
  // };

  const fetchRequestData = async () => {
    setIsLoadingRequest(true);
    try {
      let response: any = {};
      if (userData.is_viewed_guided_tour) {
        response = await get(API_ENDPOINTS.CERTIFICATE_REQUEST_BY_ID(id!));
      } else {
        if (id == '1') {
          response = TESTING_DATA.REVIEW_REQUEST;
        } else if (id == '2') {
          response = TESTING_DATA.REVIEW_REQUEST_DELIVERY;
        }
        else {
          response = TESTING_DATA.REVIEW_REQUEST_COMPLETE;
        }


      }


      if (response && response.status.toLowerCase() !== "pending approval") {
        setCertificateData({
          ...response.certificate,
          delivery_date: response.delivery_date,
        });
        // fetchCertificateData(id);
      }
      setRequestData({ ...requestData, ...response });
      return response;
    } catch (error) {
      dispatch(showError({ message: `Failed to fetch certificate details, due to some technical issue, please try again`, visible: true }))

      console.error("Failed to fetch certificate details:", error);
      setCertificateData(null);
    } finally {
      setIsLoadingRequest(false);
    }
  };

  useEffect(() => {
    fetchRequestData();
  }, [id, requests]);

  if (!requestData || Object.keys(requestData).length === 0) {
    return <div>Loading...</div>;
  }

  const handleRejectClick = () => {
    setShowRejectModal(true);
  };

  const handleDeliveryClick = () => setShowApproveModal(true);

  const handleApproveClick = () => setShowDistributorMappingModal(true);

  const handleCancelSubmit = async (internalRemarks: string) => {
    let dataToSubmit = {
      remarks: "Certificate Cancelled",
      reason: internalRemarks,
    };
    try {
      const response = await put(
        API_ENDPOINTS.CERTIFICATE_REQUESTS_CANCEL(id || ""),
        dataToSubmit
      );
      if (response) {
        dispatch(showToast({ message: "Certificate request cancelled!", type: "success" }));
        setShowCancelModal(false);
        navigate(-1);
      } else {
        dispatch(showToast({ message: "Failed to cancel certificate request. Please try again.", type: "error" }));
      }
    } catch (error) {
      dispatch(showToast({ message: "An error occurred. Failed to cancel certificate request.", type: "error" }));
      console.error("API call failed:", error);
    }
  };


  const handleRejectSubmit = async (
    reason: string,
    internalRemarks: string
  ) => {
    console.log("Rejecting with:", { reason, internalRemarks });

    let dataToSubmit = {
      remarks: internalRemarks,
      reason: reason,
    };

    try {
      const response = await put(
        `${API_ENDPOINTS.CERTIFICATE_REQUESTS_REJECT(id || "")}?userId=${userData.userId}&countryCode=IN`,
        dataToSubmit
      );
      if (response) {
        dispatch(showToast({ message: "Certificate request rejected!", type: "success" }));
        setShowRejectModal(false);
        navigate(-1);
      } else {
        dispatch(showToast({ message: "Failed to reject certificate request. Please try again.", type: "error" }));
      }
    } catch (error) {
      dispatch(showToast({ message: "An error occurred. Failed to reject certificate request.", type: "error" }));
      console.error("API call failed:", error);
    }
    setShowRejectModal(false);
  };


  const handleDeliveryinfoClick = async (data: any): Promise<boolean> => {
    let parsedData = Number(id);

    let dataToSubmit = {
      request_id: parsedData,
      partner: {
        partner_id: requestData.partner_id,
      },
      certificate_number: data.certificateNo,
      // distributors: data.distributors.map((distributor: any) => {
      //   return { partner_id: distributor.id };
      // }),
      issued_by: userData.userId,

      expiry_date: data.expiryDate,
      certificate_copy_first_page_url: data.firstPageUrl,
      certificate_copy_last_page_url: data.lastPageUrl,
    };

    let stringifieddata = JSON.stringify(dataToSubmit);
    try {
      const response = await post(API_ENDPOINTS.CERTIFICATES, stringifieddata);
      if (response) {
        dispatch(updateCurrentRequest(data.request_id));
        await fetchRequestData();
        return true;
      } else {
        dispatch(
          showError({
            message: "Failed to approve certificate request. Please try again.",
            visible: true,
          })
        );
        return false;
      }
    } catch (error: any) {
      dispatch(
        showError({
          message: `Failed to approve certificate request. Please try again. ${error.message ? error.message : ""
            }`,
          visible: true,
        })
      );
      return false;
    }
  };


  const handleDistributorMappingSubmit = async (selectedDistributors: any[]) => {
    const distributorIds = selectedDistributors.map((d: any) => d.id || d.partner_id);
    setIsSubmitting(true);
    try {
      const response = await put(
        `${API_ENDPOINTS.CERTIFICATE_REQUESTS_APPROVE(id || "")}?userId=${userData.userId}`,
        { distributor_ids: distributorIds }
      );
      if (response) {
        dispatch(showToast({ message: "Certificate request approved successfully!", type: "success" }));
        setShowDistributorMappingModal(false);
        navigate(-1);
      } else {
        dispatch(
          showError({
            message: "Failed to approve certificate request. Please try again.",
            visible: true,
          })
        );
      }
    } catch (error: any) {
      dispatch(
        showError({
          message: `Failed to approve certificate request. ${error.message || ""}`,
          visible: true,
        })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeliveryCodeClick = () => setShowDeliveryCodeModal(true);

  const handleDeliveryCodeSubmit = async (deliveryCode: string) => {
    if (deliveryCode === requestData.delivery_code) {
      try {
        const response = await post(
          `${API_ENDPOINTS.CERTIFICATE_REQUESTS_DELIVER(
            requestData.request_id
          )}?delivery_code=${deliveryCode}`,
          {}
        );
        if (response) {
          dispatch(updateCurrentRequestActive(requestData.request_id));
          navigate(-1);
        }
        console.log("Status updated to Active successfully.");
      } catch (error: any) {
        dispatch(
          showError({
            message: error.message,
            visible: true,
          })
        );
        console.error("Failed to update status:", error);
      }
    } else {
      dispatch(showToast({ message: "Delivery code mismatch!", type: "error" }));
    }

    setShowDeliveryCodeModal(false);
  };

  const getStatusClass = (status: string) => {
    switch (status.toLowerCase()) {
      case "pending approval":
        return "status-pending";
      case "pending delivery":
        return "status-pending-delivery";
      case "active":
        return "status-active";
      case "rejected":
      case "expired":
        return "status-pill-rejected";
      case "cancelled":
        return "status-cancelled";
      default:
        return "";
    }
  };

  return (
    <div
      style={{
        background: "rgb(236, 239, 241)",
        padding: 30,
        paddingTop: 100,
        paddingBottom: 80,
      }}
    >
      {(isSubmitting || isLoadingRequest) && <Loader />}
      <div style={{ paddingBottom: 0 }}>
        <button className="back-button" onClick={() => navigate(-1)}>
          <img src={BackArrow} height={20} style={{ marginRight: 10 }} />{" "}
          {certificateData
            ? "Certificate Details"
            : "Review Certificate Request"}
        </button>
      </div>
      <div className="review-request-container">
        <div className="review-request-header">
          <div className="header-item">
            <label>Firm Name</label>
            <span style={{maxWidth: 200, wordBreak:'break-word'}}>{requestData.firm_name}</span>
          </div>
          <div className="header-item">
            <label>BRP ID</label>
            <span>{requestData.partner_id}</span>
          </div>
          <div className="header-item">
            <label>Submitted On</label>
            <span>{formatDateToDDMMYYYY(requestData.created_at)}</span>
          </div>
          <div className={`status-pill ${getStatusClass(requestData.status)}`}>
            {requestData.status.toLowerCase() === "approved"
              ? "Pending Delivery"
              : requestData.status}
          </div>
        </div>

        <div className="submitted-details-section">
          <span className="heading">Submitted Details</span>
          <div className="details-grid">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 24,
              }}
            >
              <div className="detail-item">
                <label>Unique Request ID</label>
                <span>
                  {requestData.govt_application_number
                    ? requestData.govt_application_number
                    : requestData.request_id}
                </span>
                {requestData.govt_application_number && (
                  <p>(Request ID as per Mahaparwana govt. site)</p>
                )}
              </div>
              <div className="detail-item">
                <label>Firm Name (as per License)</label>
                <span>{requestData.firm_name}</span>
              </div>
              <div className="detail-item">
                <label>GST Number</label>
                <span>{requestData.gst_number}</span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 24,
              }}
            >
              <div className="detail-item">
                <label>License Number</label>
                <span>{requestData.license_number}</span>
              </div>
              <div className="detail-item">
                <label>License Issue Date</label>
                <span>
                  {formatDateToDDMMYYYY(requestData.license_issued_date)}
                </span>
              </div>
              <div className="detail-item">
                <label>License Expiry Date</label>
                <span>
                  {formatDateToDDMMYYYY(requestData.license_expiry_date)}
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 24,
              }}
            >
              <div className="detail-item">
                <label>License copy</label>
                {requestData.license_documents &&
                  requestData.license_documents.map((item: any) => {
                    return (
                      <span>
                        <a
                          href={item.document_url}
                          className="link-button"
                          target="_blank"
                          rel="noopener noreferrer"
                        // onClick={() =>
                        //   downloadFile(item.document_url, getFileNameFromUrl(item.document_url))
                        // }
                        >
                          Download
                          <img
                            src={Download}
                            height={20}
                            style={{ marginLeft: 5, marginTop: 5 }}
                          />
                        </a>
                      </span>
                    );
                  })}
              </div>
              <div className="detail-item">
                <label>Products for Certificate</label>
                <span>{requestData.products.join(", ")}</span>
              </div>
              <div className="detail-item">
                <label>Shop Address</label>
                <span>
                  {requestData.shop_address + ", " + requestData.shop_district + ", " + requestData.shop_pincode}
                </span>
              </div>
            </div>

            <div className="detail-item full-row">
              <label>Godown Address</label>
              <span>{requestData.godown_address + ", " + requestData.godown_district + ", " + requestData.godown_pincode}</span>
            </div>
          </div>
        </div>

        {certificateData && certificateData.certificate_number && requestData.status.toLowerCase() !== "rejected" && (
          <div className="submitted-details-section">
            <span className="heading">Certificate Details</span>
            <div className="details-grid">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 24,
                }}
              >
                <div className="detail-item">
                  <label>Certificate copy</label>
                  <span>
                    <a
                      href={certificateData.certificate_copy_first_page_url}
                      className="link-button"
                      target="_blank"
                      rel="noopener noreferrer"
                    // onClick={() =>
                    //   downloadFile(certificateData.certificate_copy_first_page_url, getFileNameFromUrl(certificateData.certificate_copy_first_page_url))
                    // }
                    >
                      Download First Page
                      <img
                        src={Download}
                        height={20}
                        style={{ marginLeft: 5, marginTop: 5 }}
                      />
                    </a>
                  </span>
                  <span>
                    <a
                      href={certificateData.certificate_copy_last_page_url}
                      className="link-button"
                      target="_blank"
                      rel="noopener noreferrer"
                    // onClick={() =>
                    //   downloadFile(certificateData.certificate_copy_last_page_url, getFileNameFromUrl(certificateData.certificate_copy_last_page_url))
                    // }
                    >
                      Download Last Page
                      <img
                        src={Download}
                        height={20}
                        style={{ marginLeft: 5, marginTop: 5 }}
                      />
                    </a>
                  </span>
                </div>
                <div className="detail-item">
                  <span>
                    <label>Issue Date</label>
                    <img
                      src={Info}
                      height={14}
                      width={14}
                      className="role-info-icon"
                      title={`Date of Certificate Approval and Issuance`}
                      alt="info"
                    />
                  </span>
                  <span>
                    {formatDateToDDMMYYYY(certificateData.issued_date)}
                  </span>
                </div>
                <div className="detail-item">
                  <span>
                    <label>Expiry Date</label>
                    <img
                      src={Info}
                      height={14}
                      width={14}
                      className="role-info-icon"
                      title={`Date when the certificate becomes invalid`}
                      alt="info"
                    />
                  </span>
                  <span>
                    {formatDateToDDMMYYYY(certificateData.expiry_date)}
                  </span>
                </div>
                <div className="detail-item">
                  <span>
                    <label>Delivery Date</label>
                    <img
                      src={Info}
                      height={14}
                      width={14}
                      className="role-info-icon"
                      title={`Date the certificate is sent to the Channel Partner`}
                      alt="info"
                    />
                  </span>
                  <span>
                    {formatDateToDDMMYYYY(certificateData.delivery_date)}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 24,
                }}
              >
                <div className="detail-item">
                  <label>Certificate No</label>
                  <span>{certificateData.certificate_number}</span>
                </div>
                <div className="detail-item">
                  <label>Issued By</label>

                  <span>{requestData.assigned_to}</span>
                </div>
                <div className="detail-item">
                 {requestData.distributors &&  <label>Distributor Mapping</label>}
                  {requestData.distributors}
                </div>
                <div className="detail-item">
                  <label></label>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        )}

        {requestData.status.toLowerCase() == "rejected" && (
          <div className="submitted-details-section">
            <span className="heading">Reason For Rejection</span>
            <div className="details-grid">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <div className="detail-item">
                  <label>Reason Visible to partner</label>
                  <span>{requestData.reason}</span>
                </div>
                <div className="detail-item">
                  <label>Internal Remarks</label>
                  <span>{requestData.remarks}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {!Object.keys(VIEWER_ROLES).includes(userData.role) && !isReadOnly && <div className="action-buttons-container">
          {requestData.status.toLowerCase() ===
            RequestState.APPROVED.toLowerCase() &&
            (userData.role === ROLES.ISSUER || userData.role === ROLES.APPROVER) && (
              <span className="infoText">
                Deliver Certificate By : {requestData.due_date}
              </span>
            )}
          {requestData.status.toLowerCase() ===
            RequestState.PENDING.toLowerCase() &&
            (userData.role === ROLES.ISSUER ||userData.role === ROLES.APPROVER) && (
              <span className="infoText">
                Approve Or Reject By :{" "}
                {formatDateToDDMMYYYY(requestData.due_date)}
              </span>
            )}
          {requestData.status.toLowerCase() ===
            RequestState.PENDING.toLowerCase() &&
            (userData.role === ROLES.ISSUER || userData.role === ROLES.APPROVER) && (
              <span>
                <button className="reject-button" onClick={handleRejectClick}>
                  Reject
                </button>
                <button className="approve-button" onClick={handleApproveClick}>
                  Approve
                </button>
              </span>
            )}
            {requestData.status.toLowerCase() ===
            RequestState.PENDING_DELIVERY.toLowerCase() &&
            (userData.role === ROLES.ISSUER || userData.role === ROLES.APPROVER) && <span></span>}
             {requestData.status.toLowerCase() ===
            RequestState.PENDING_DELIVERY.toLowerCase() &&
            (userData.role === ROLES.ISSUER || userData.role === ROLES.APPROVER) && (
              requestData?.unit === 'IN57' && certificateData?.certificate_number ? (
                <span className="infoText">
                  Certificate will be delivered via third-party. Awaiting retailer confirmation.
                </span>
              ) : (
                <span>
                  <button className="approve-button" onClick={handleDeliveryClick}>
                    Deliver Certificate
                  </button>
                </span>
              )
            )}



          {/* {requestData.status.toLowerCase() ===
            RequestState.PENDING_DELIVERY.toLowerCase() &&
            userData.role === ROLES.ISSUER && (
              <button
                className="delivery-button"
                onClick={handleDeliveryCodeClick}
              >
                Enter Delivery Code
              </button>
            )} */}

          {requestData.status.toLowerCase() === "active" && (
            <button
              className="cancel-button"
              onClick={() => setShowCancelModal(true)}
              style={{ background: "#c93131", color: "#fff" }}
            >
              Cancel Certificate
            </button>
          )}
        </div>}
      </div>
      <DistributorMappingModal
        show={showDistributorMappingModal}
        onClose={() => setShowDistributorMappingModal(false)}
        onSubmit={handleDistributorMappingSubmit}
        preselectedDistributorIds={requestData?.distributor_ids || []}
        partnerType={requestData?.partner_type}
        unitCode={requestData?.unit}
      />

      <CancelModal
        show={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        onSubmit={handleCancelSubmit}
      />
      {showApproveModal && (
        <ApproveModal
          show={showApproveModal}
          onClose={() => setShowApproveModal(false)}
          onSubmit={handleDeliveryinfoClick}
          onDeliveryCodeSubmit={handleDeliveryCodeSubmit}
          isMH={
            requestData.govt_application_number
              ? requestData.govt_application_number
              : ""
          }
          bookletData={bookletData}
          partnerData={{ partnerId: requestData.partner_id, requestId: id }}
          initialStep={certificateData?.certificate_number ? 2 : 1}
          unitCode={requestData?.unit}
        />
      )}

      <RejectModal
        show={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        onSubmit={handleRejectSubmit}
      />


      <DeliveryCodeModal
        show={showDeliveryCodeModal}
        onClose={() => setShowDeliveryCodeModal(false)}
        onSubmit={handleDeliveryCodeSubmit}
      />
    </div>
  );
};

export default ReviewRequestPage;
